import { Dispatch, SetStateAction } from 'react';
import { useMutation } from '@tanstack/react-query';
import { createStripeCheckoutSession } from 'src/api';

type Props = {
  setClientSecret: Dispatch<SetStateAction<string>>;
  handleError: (errorCode: string) => void;
};
export const useCreateStripeCheckoutSession = ({
  setClientSecret,
  handleError,
}: Props) => {
  return useMutation({
    mutationFn: createStripeCheckoutSession,
    onSuccess: (data) => {
      setClientSecret(data.clientSecret);
    },
    onError: (error) => {
      handleError(error.message);
    },
  });
};
